import React, { useContext } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import styled, { ThemeProvider } from "styled-components";
import { darkTheme } from "./theme/theme";
import { UserContext } from "./context/UserContext";

// Layout and Pages
import Home from "./Home";
import Services from "./menu/Services";
import Layout from "./layout/Layout";
import IssuesList from "./menu/Issues";
import DevelopersScreen from "./menu/Deverlopers";
import ContactUs from "./menu/ContactUs";
import AboutUs from "./menu/AboutUs";
import Projects from "./menu/Projects";
import BuildMyPortfolio from "./BuildMyPortfolio";
import CourseDetailPage from "./CourseDetailPage";
import Checkout from "./Checkout";
import MyCourses from "./MyCourses";
import MyProfile from "./MyProfile";
import RnInterviewPrep from "./RnInterviewPrep";
import QuestionsScreen from "./QuestionsScreen";
import GlobalToast from "./components/GlobalToast";
import TermsAndConditions from "./TermsCondition";
import PrivacyPolicy from "./PrivacyPolicy";
import RefundPolicy from "./RefundPolicy";
import CourseList from "./CourseList";
import AdminPanel from "./AminPanel";
import AddCoursePage from "./AddCourseDetailPage";
import EditCoursePage from "./EdictCourse";
import EditProfile from "./EditProfile";
import ChangePassword from "./ChangePassword";
import AdminRoute from "./components/AdminRoute";
import AddBlog from "./AddBlog";
import BlogDetail from "./BlogDetail";
import EditBlog from "./EditBlog";
import AddCodeShop from "./AddCodeShop";
import AddInterviewPrep from "./AddInterviewPrep";
import InterviewPrepDetail from "./InterviewPrepDetail";
import AddPrepItem from "./AddPrepItem";
import ForgotPassword from "./ForgotPassword";
import AdminLogin from "./admin/AdminLogin";
import AdminCourseDetail from "./admin/AdminCourseDetail";
import EditCodeShop from "./EdiCodeShop";
import AddReadyCode from "./AddReadyCode";
import EditReadyCode from "./EditReadyCode";
import AddInterviewTopic from "./AddInterviewTopic";
import AddModule from "./AddModule";
import ModuleDetail from "./ModuleDetail";
import TopicDetail from "./TopicDetail";
import AddDemo from "./AddDemo";
import AddCareer from "./AddCareer";
import AddFAQ from "./AddFAQ";
import AddPlanningTask from "./AddPlanningTask";

const Wrapper = styled.div`
  font-family: "Poppins", sans-serif;
  background-color: #000;
  color: #fff;
  min-height: 100vh;
`;

function App() {
  const { user, authLoading } = useContext(UserContext);
  console.log("user", user);

  const adminEntry = authLoading ? (
    <div
      style={{
        minHeight: "100vh",
        background: "#0a0d12",
        color: "#fff",
        display: "grid",
        placeItems: "center",
      }}
    >
      Checking admin access...
    </div>
  ) : user?.role === "admin" ? (
    <AdminPanel />
  ) : (
    <AdminLogin />
  );

  return (
    <ThemeProvider theme={darkTheme}>
      <Router>
        <Wrapper>
          <Routes>
            {/* 👇 Default route depends on role */}

            {/* Admin Protected Routes */}
            <Route
              path="/"
              element={adminEntry}
            />

            <Route
              path="/add-course"
              element={
                <AdminRoute>
                  <AddCoursePage />
                </AdminRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <AdminRoute>
                  <AdminPanel />
                </AdminRoute>
              }
            />
            <Route
              path="/demos"
              element={
                <AdminRoute>
                  <AdminPanel />
                </AdminRoute>
              }
            />
            <Route
              path="/careers"
              element={
                <AdminRoute>
                  <AdminPanel />
                </AdminRoute>
              }
            />
            <Route
              path="/faqs"
              element={
                <AdminRoute>
                  <AdminPanel />
                </AdminRoute>
              }
            />
            <Route
              path="/planning"
              element={
                <AdminRoute>
                  <AdminPanel />
                </AdminRoute>
              }
            />
            <Route
              path="/add-demo"
              element={
                <AdminRoute>
                  <AddDemo />
                </AdminRoute>
              }
            />
            <Route
              path="/add-career"
              element={
                <AdminRoute>
                  <AddCareer />
                </AdminRoute>
              }
            />
            <Route
              path="/add-faq"
              element={
                <AdminRoute>
                  <AddFAQ />
                </AdminRoute>
              }
            />
            <Route
              path="/add-planning"
              element={
                <AdminRoute>
                  <AddPlanningTask />
                </AdminRoute>
              }
            />
            <Route
              path="/edit-course/:id"
              element={
                <AdminRoute>
                  <EditCoursePage />
                </AdminRoute>
              }
            />
            <Route
              path="/courses/:id"
              element={
                <AdminRoute>
                  <AdminCourseDetail />
                </AdminRoute>
              }
            />
            <Route
              path="/add-blog"
              element={
                <AdminRoute>
                  <AddBlog />
                </AdminRoute>
              }
            />
            <Route
              path="/blogs/:slug"
              element={
                <AdminRoute>
                  <BlogDetail />
                </AdminRoute>
              }
            />
            <Route
              path="/edit-blog/:id"
              element={
                <AdminRoute>
                  <EditBlog />
                </AdminRoute>
              }
            />
            <Route
              path="/add-codeshop"
              element={
                <AdminRoute>
                  <AddCodeShop />
                </AdminRoute>
              }
            />
            <Route
              path="/edit-codeshop/:id"
              element={
                <AdminRoute>
                  <EditCodeShop />
                </AdminRoute>
              }
            />

            <Route
              path="/add-interviewprep"
              element={
                <AdminRoute>
                  <AddInterviewPrep />
                </AdminRoute>
              }
            />
            <Route
              path="/add-readycode"
              element={
                <AdminRoute>
                  <AddReadyCode />
                </AdminRoute>
              }
            />
            <Route
              path="/module-detail/:prepId/:moduleId"
              element={
                <AdminRoute>
                  <ModuleDetail />
                </AdminRoute>
              }
            />
            <Route
              path="/add-topic/:prepId/:moduleId"
              element={
                <AdminRoute>
                  <AddInterviewTopic />
                </AdminRoute>
              }
            />
            <Route
              path="/topic-detail/:prepId/:moduleId/:topicId"
              element={
                <AdminRoute>
                  <TopicDetail />
                </AdminRoute>
              }
            />
            <Route
              path="/add-module/:prepId"
              element={
                <AdminRoute>
                  <AddModule />
                </AdminRoute>
              }
            />
            <Route
              path="/edit-readycode/:id"
              element={
                <AdminRoute>
                  <EditReadyCode />
                </AdminRoute>
              }
            />

            <Route
              path="/interview-prep/:prepId"
              element={
                <AdminRoute>
                  <InterviewPrepDetail />
                </AdminRoute>
              }
            />
            <Route
              path="/add-prep-item/:prepId"
              element={
                <AdminRoute>
                  <AddPrepItem />
                </AdminRoute>
              }
            />
          </Routes>
          <GlobalToast />
        </Wrapper>
      </Router>
    </ThemeProvider>
  );
}

export default App;
